import type { WhitespaceValueSalesLegendData } from 'components/pages/WhitespaceAnalysis/whitespaceGridKpiAxis.helpers';

const LEGEND_VALUE_CLASS = 'shrink-0 text-[14px] font-normal leading-[22px] text-toolbarLabelGrey';

const WhitespaceValueSalesLegend = ({
    label,
    minLabel,
    maxLabel,
    gradientStartColor,
    gradientEndColor,
}: WhitespaceValueSalesLegendData) => (
    <div className="flex items-center gap-2">
        <span className="shrink-0 text-[14px] font-medium text-blackTitle">{label}</span>
        <div className="flex items-center gap-1">
            <span className={LEGEND_VALUE_CLASS}>{minLabel}</span>
            <div
                className="h-4 w-20 shrink-0 rounded-[4px]"
                style={{
                    background: `linear-gradient(to right, ${gradientStartColor}, ${gradientEndColor})`,
                }}
                aria-hidden
            />
            <span className={LEGEND_VALUE_CLASS}>{maxLabel}</span>
        </div>
    </div>
);

export default WhitespaceValueSalesLegend;
